/**
 * @flow
 */

import React, { useState } from 'react';
import gql from 'graphql-tag';
import { FormattedMessage, injectIntl } from 'react-intl';
import { useQuery } from '@apollo/client';
import { get } from 'lodash';
import { Container, Menu } from 'semantic-ui-react';

import type { IntlShape } from 'react-intl';

import { PageHeader } from '../../../components';

import ReportMenu from '../containers/ReportMenu';
import InventoryMenu from '../containers/InventoryMenu';
import ProductList from './ProductList';
import Report from './Report';

type SuppliersPageProps = {
    intl: IntlShape,
};

export const GET_SALONS_QUERY = gql`
    query getSalons {
        viewer {
            id
            ... on Supplier {
                id
                salons {
                    id
                    name
                    address
                    masters {
                        nodes {
                            id
                            firstName
                            lastName
                            email
                            phone
                        }
                    }
                    administrators {
                        id
                        firstName
                        lastName
                        email
                        phone
                    }
                }
                manufacturers {
                    id
                    name
                    salon
                    salonName
                }
            }
        }
    }
`;

const WarehousePage = ({ intl }: SuppliersPageProps) => {
    const [activeItem, setActiveItem] = useState('report');

    const { data } = useQuery(GET_SALONS_QUERY, {
        fetchPolicy: 'cache-and-network',
    });

    const salons = get(data, 'viewer.salons');
    const manufacturers = get(data, 'viewer.manufacturers');

    return (
        <Container fluid>
            <PageHeader>
                <FormattedMessage
                    id="pages.warehouse.label"
                    defaultMessage="Warehouse"
                />
            </PageHeader>
            <Menu pointing>
                <Menu.Item
                    name="report"
                    active={activeItem === 'report'}
                    onClick={(e, { name }) => setActiveItem(name)}
                >
                    <FormattedMessage
                        id="pages.warehouse.report.label"
                        defaultMessage="Report"
                    />
                </Menu.Item>
                <Menu.Item
                    name="inventory"
                    active={activeItem === 'inventory'}
                    onClick={(e, { name }) => setActiveItem(name)}
                >
                    <FormattedMessage
                        id="pages.warehouse.inventory.label"
                        defaultMessage="Inventory"
                    />
                </Menu.Item>
                {activeItem === 'report' ? (
                    <ReportMenu
                        salons={salons}
                        manufacturers={manufacturers}
                        intl={intl}
                    />
                ) : (
                    <InventoryMenu salons={salons} intl={intl} />
                )}
            </Menu>
            {activeItem === 'report' ? <Report /> : <ProductList />}
        </Container>
    );
};

export default injectIntl(WarehousePage);
